import { useEffect, useState } from 'react';
import Icon from 'beek-design-system/Elements/Icon';
import styled from 'styled-components';

type CheckboxProps = {
  onChange?: (value: boolean) => void;
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
  hover?: boolean;
  clickContainer?: boolean;
};

type IconContainerProps = {
  checked: boolean;
  hover: boolean;
  clickContainer: boolean;
};

const defaultProps = {
  marginTop: '0rem',
  marginBottom: '0rem',
  marginLeft: '0rem',
  marginRight: '0rem',
  onChange: (): void => {},
  hover: false,
  clickContainer: false,
};

const CheckboxInput = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  background: var(--white);
  border: 0.125rem solid var(--gray-35);
  border-radius: 0.375rem;
`;
const MainContainer = styled.div<CheckboxProps>`
  width: 1.5rem;
  height: 1.5rem;
  position: relative;
  margin-top: ${(props): string | undefined => props.marginTop};
  margin-bottom: ${(props): string | undefined => props.marginBottom};
  margin-left: ${(props): string | undefined => props.marginLeft};
  margin-right: ${(props): string | undefined => props.marginRight};
`;
const IconContainer = styled.div<IconContainerProps>`
  position: absolute;
  width: 0.867rem;
  height: 0.644rem;
  margin-top: 0.438rem;
  margin-bottom: 0.418rem;
  margin-left: 0.313rem;
  margin-right: 0.321rem;
  display: ${(props): string => (props.checked ? 'block' : 'none')};
  @media ${({ theme }): string => theme.devices.laptop} {
    display: ${(props): string =>
      props.checked || props.hover || props.clickContainer ? 'block' : 'none'};
  }
`;

const Checkbox = ({
  onChange,
  marginTop,
  marginBottom,
  marginRight,
  marginLeft,
  hover,
  clickContainer,
}: CheckboxProps): JSX.Element => {
  const styleProps = {
    marginTop,
    marginBottom,
    marginRight,
    marginLeft,
  };
  const [value, setValue] = useState(false);

  useEffect(() => {
    if (clickContainer !== undefined && clickContainer !== value) {
      setValue(clickContainer);
    }
  }, [clickContainer, value]);

  const handleCheckbox = (): void => {
    setValue(!value);
    if (onChange) {
      onChange(!value);
    }
  };

  return (
    <MainContainer
      onClick={(): void => handleCheckbox()}
      {...styleProps}
      data-testid="checkbox"
    >
      <IconContainer
        checked={value}
        hover={hover || false}
        clickContainer={clickContainer || false}
      >
        <Icon
          name="check"
          marginBottom="0.625rem"
          colorVariant="gray100"
          hover={clickContainer ? false : hover}
        />
      </IconContainer>
      <CheckboxInput />
    </MainContainer>
  );
};

Checkbox.defaultProps = defaultProps;

export default Checkbox;
